import { render, staticRenderFns } from "./CreateBankTransfer.vue?vue&type=template&id=15831756&scoped=true"
import script from "./CreateBankTransfer.vue?vue&type=script&lang=ts"
export * from "./CreateBankTransfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15831756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15831756')) {
      api.createRecord('15831756', component.options)
    } else {
      api.reload('15831756', component.options)
    }
    module.hot.accept("./CreateBankTransfer.vue?vue&type=template&id=15831756&scoped=true", function () {
      api.rerender('15831756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/CreateBankTransfer.vue"
export default component.exports